import { render, staticRenderFns } from "./quickAddMyCourse.vue?vue&type=template&id=c4b9af96&scoped=true"
import script from "./quickAddMyCourse.vue?vue&type=script&lang=js"
export * from "./quickAddMyCourse.vue?vue&type=script&lang=js"
import style0 from "./quickAddMyCourse.vue?vue&type=style&index=0&id=c4b9af96&prod&lang=less"
import style1 from "./quickAddMyCourse.vue?vue&type=style&index=1&id=c4b9af96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b9af96",
  null
  
)

export default component.exports